<template>
  <section class="result">
    <div class="result__icon">
      <van-image width="100" height="100" :src="fail_img" />
    </div>
    <div class="result__title">开票失败</div>
    <div class="result__remark">
      开票失败，请联系管理员。
    </div>
  </section>
</template>

<script>
import fail_img from '@/assets/payment-related/img_pay_fail.png'
import { Image } from 'vant'
export default {
  name: 'InvoiceFail',
  components: {
    [Image.name]: Image
  },
  data () {
    return {
      fail_img
    }
  }
}
</script>

<style lang="scss" scoped>
.result {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  text-align: center;
  color: #444444;
  padding-top: 10vh;
  &__title {
    font-size: 22px;
    line-height: 48px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    letter-spacing: 1.75px;
  }
  &__remark {
    font-size: 14px;
    font-family: PingFang-SC-Medium;
    letter-spacing: 1.25px;
    font-weight: bold;
  }
  &__orderInfo {
    font-size: 14px;
    line-height: 24px;
    font-family: PingFang-SC-Medium;
    letter-spacing: 1.25px;
    font-weight: bold;
  }
}
</style>
